module.exports = [
    {
        title: 'Расположение',
        list: [
            {
                title: 'Округ',
                name: 'location[okrug][]'
            },
            {
                title: 'Метро',
                name: 'metro[]'
            },
            {
                title: 'Ветка метро',
                name: 'branch[]'
            },
            {
                title: 'Город',
                name: 'location[city][]'
            },
            {
                title: 'Улица',
                name: 'location[street][]'
            },
            {
                title: 'Район',
                name: 'location[raion][]'
            },
            {
                title: 'Область',
                name: 'location[oblast][]'
            },
            {
                title: 'Место',
                name: 'building[]'
            }
        ]
    },
    {
        title: 'Кухня | Блюда и напитки',
        list: [
            {
                title: 'Кухня',
                name: 'kitchen[]'
            },
            {
                title: 'Направленность',
                name: 'direction[]'
            },
            {
                title: 'Поиск блюда',
                name: 'food[]'
            },
            {
                title: 'Бизнес-ланч',
                name: 'options[lunch]'
            },
            {
                title: 'Пенное',
                name: 'options[beer]'
            },
            {
                title: 'Меню на англ.',
                is_simple: true,
                name: 'options[english_menu]'
            },
            {
                title: 'Коктейли',
                is_simple: true,
                name: 'options[cocktails]'
            },
            {
                title: 'Бранчи',
                is_simple: true,
                name: 'good_for[]=17'
            },
            {
                title: 'Доставка еды',
                is_simple: true,
                name: 'dostavka'
            },
            {
                title: 'Кейтеринг',
                is_simple: true,
                name: 'catering'
            }
        ]
    },
    {
        title: 'Тип заведения',
        list: [
            {
                title: 'Тип',
                name: 'type[]'
            },
            {
                title: 'Основной тип',
                name: 'mainType[]'
            },
            {
                title: 'Сеть',
                name: 'chain'
            }
        ]
    },
    {
        title: 'Особенности',
        list: [
            {
                title: 'Новые (недавно открывшиеся)',
                is_simple: true,
                name: 'newest'
            },
            {
                title: 'Алкоголь с собой',
                name: 'alco-with-self'
            },
            {
                title: 'Вместимость зала',
                name: 'capacity'
            },
            {
                title: 'Другие особенности',
                name: 'good_for[]'
            }
        ]
    },
    {
        title: 'Банкет',
        list: [
            {
                title: 'Хорошо подходит для',
                name: 'banket[good_for][]'
            },
            {
                title: 'Что можно с собой',
                name: 'banket[with_self][]'
            },
            {
                title: 'Вместимость зала',
                name: 'banket[capacity]'
            }
        ]
    }
]